import { string, number } from 'prop-types';
import {
  arrayOf as arrayType, params, shape as shapeType, string as stringType
} from '@thd-nucleus/data-sources';

export const dataModelRelatedProducts = {
  relatedSearchModel: params({ itemId: stringType(), navParam: stringType(), storeId: stringType() }).shape({
    products: arrayType(shapeType({
      itemId: stringType(),
      media: shapeType({
        images: arrayType(shapeType({
          url: stringType()
        }).client())
      }),
      identifiers: shapeType({
        canonicalUrl: stringType(),
        productLabel: stringType()
      }),
      details: shapeType({
        description: stringType()
      })
    })),
  }),
};

export const propTypesRelatedProducts = {
  itemId: string,
  maxRelatedProducts: number,
  navParam: string,
  storeId: string,
};